import { useState } from 'react';
import { Link } from 'react-router-dom';

const services = [
  {
    icon: 'ri-line-chart-line',
    title: '経営戦略策定',
    description: '企業の現状分析から将来ビジョンの設定まで、実行可能な経営戦略を共に策定します。市場環境の変化に対応した柔軟な戦略立案が強みです。',
  },
  {
    icon: 'ri-team-line',
    title: '組織開発・人材育成',
    description: '強い組織をつくるための人材育成プログラムと組織文化の醸成を支援します。リーダーシップ開発から現場力強化まで幅広く対応します。',
  },
  {
    icon: 'ri-funds-line',
    title: '財務・収益改善',
    description: '財務状況の可視化と収益構造の改善を通じて、企業の財務健全性を高めます。コスト削減から新たな収益源の開拓まで包括的に支援します。',
  },
  {
    icon: 'ri-settings-3-line',
    title: '業務プロセス改革',
    description: '非効率な業務フローを見直し、生産性向上と品質改善を実現します。デジタル化推進も含めた現代的なプロセス改革を提案します。',
  },
  {
    icon: 'ri-global-line',
    title: '新規事業開発',
    description: '新たなビジネス機会の発掘から事業計画の策定、立ち上げ支援まで一貫してサポートします。リスクを最小化しながら成長機会を最大化します。',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'リスクマネジメント',
    description: '経営リスクの特定・評価・対策立案を通じて、企業の持続可能な成長を守ります。危機管理体制の構築と事業継続計画の策定を支援します。',
  },
];

const newBusiness = {
  icon: 'ri-megaphone-line',
  title: 'SNS運用代行',
  description:
    '新たに開始したSNS運用代行では、情報発信の企画立案から投稿設計、運用改善までを一貫して支援します。企業の魅力を継続的に届ける運用体制づくりをサポートします。',
};

export default function ServicesSection() {
  const [hovered, setHovered] = useState<number | null>(null);

  return (
    <section id="services" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="flex flex-col items-center mb-14">
          <span className="border border-yellow-400 text-yellow-600 text-xs font-bold tracking-widest uppercase px-4 py-1.5 rounded-full mb-4">SERVICES</span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 text-center leading-snug mb-4">
            私たちが提供する、<br />経営コンサルティング
          </h2>
          <p className="text-gray-500 text-sm md:text-base text-center max-w-lg">
            組織・戦略・人材に加え、新たにSNS運用代行にも対応しています。
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {services.map((service, idx) => (
            <div
              key={service.title}
              onMouseEnter={() => setHovered(idx)}
              onMouseLeave={() => setHovered(null)}
              className={`rounded-xl p-7 flex flex-col gap-4 transition-all duration-300 cursor-pointer border ${
                hovered === idx
                  ? 'bg-yellow-400 border-yellow-400'
                  : 'bg-gray-50 border-gray-100 hover:border-yellow-200'
              }`}
            >
              <div className={`w-12 h-12 flex items-center justify-center rounded-lg transition-colors ${
                hovered === idx ? 'bg-yellow-300' : 'bg-white'
              }`}>
                <i className={`${service.icon} text-xl ${hovered === idx ? 'text-gray-900' : 'text-yellow-500'}`} />
              </div>
              <h3 className={`font-bold text-base transition-colors ${hovered === idx ? 'text-gray-900' : 'text-gray-800'}`}>
                {service.title}
              </h3>
              <p className={`text-sm leading-relaxed transition-colors ${hovered === idx ? 'text-gray-800' : 'text-gray-500'}`}>
                {service.description}
              </p>

            </div>
          ))}
        </div>

        <div className="mt-12">
          <div className="mb-6 flex flex-col items-start gap-2">
            <span className="rounded-full border border-yellow-400 px-3 py-1 text-xs font-bold tracking-widest text-yellow-600 uppercase">
              NEW BUSINESS
            </span>
            <h3 className="text-2xl font-bold text-gray-800">新規事業</h3>
            <p className="text-sm text-gray-500">
              新たに開始した取り組みとして、SNS運用代行のご相談にも対応しています。
            </p>
          </div>

          <div
            onMouseEnter={() => setHovered(services.length)}
            onMouseLeave={() => setHovered(null)}
            className={`rounded-xl border p-7 transition-all duration-300 cursor-pointer ${
              hovered === services.length
                ? 'border-yellow-400 bg-yellow-400'
                : 'border-gray-100 bg-gray-50 hover:border-yellow-200'
            }`}
          >
            <div className="flex flex-col gap-5 lg:flex-row lg:items-start lg:justify-between">
              <div className="flex flex-col gap-4">
                <div
                  className={`flex h-12 w-12 items-center justify-center rounded-lg transition-colors ${
                    hovered === services.length ? 'bg-yellow-300' : 'bg-white'
                  }`}
                >
                  <i
                    className={`${newBusiness.icon} text-xl ${
                      hovered === services.length ? 'text-gray-900' : 'text-yellow-500'
                    }`}
                  />
                </div>
                <div>
                  <h4
                    className={`text-lg font-bold transition-colors ${
                      hovered === services.length ? 'text-gray-900' : 'text-gray-800'
                    }`}
                  >
                    {newBusiness.title}
                  </h4>
                  <p
                    className={`mt-2 max-w-3xl text-sm leading-relaxed transition-colors ${
                      hovered === services.length ? 'text-gray-800' : 'text-gray-500'
                    }`}
                  >
                    {newBusiness.description}
                  </p>
                </div>
              </div>
              <div className="flex flex-col items-start gap-3 lg:items-end">
                <div
                  className={`inline-flex items-center rounded-full px-4 py-2 text-xs font-semibold ${
                    hovered === services.length
                      ? 'bg-gray-900 text-white'
                      : 'bg-white text-gray-700'
                  }`}
                >
                  新たに開始したサービス
                </div>
                <Link
                  to="/services/sns-management"
                  className={`inline-flex items-center gap-2 rounded-full px-5 py-3 text-sm font-semibold transition-colors ${
                    hovered === services.length
                      ? 'bg-white text-gray-900 hover:bg-gray-100'
                      : 'bg-gray-900 text-white hover:bg-gray-700'
                  }`}
                >
                  詳しく見る
                  <i className="ri-arrow-right-line" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
